import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { applyUnicodeFontSupportFromText } from './reportBuilder/fonts';

const HEADER_COLOR = [0, 31, 92]; // Navy blue

export function downloadCSV(rows, filename) {
  const csvContent = rows.map(r => r.map(c => {
    const str = String(c ?? '');
    return str.includes(',') || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
  }).join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function buildPDF(sections, filename) {
  const doc = new jsPDF();
  let y = 15;

  doc.setFontSize(14);
  doc.text(filename.replace(/_/g, ' '), 14, y);
  y += 5;
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 14, y);
  y += 10;
  doc.setTextColor(0);

  sections.forEach((section) => {
    if (y > 260) { doc.addPage(); y = 15; }
    doc.setFontSize(11);
    doc.text(section.title, 14, y);
    y += 2;

    autoTable(doc, {
      startY: y,
      head: [section.headers],
      body: section.rows,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: HEADER_COLOR },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 10;
  });

  doc.save(`${filename}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
